import React from 'react';
import './utils/JavascriptPrototypeFunctions';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import CustomThemeProvider from './theme/CustomThemeProvider';
import Login from './screens/Login/Login';
import HomeLayout from './containers/HomeLayout';
import { ROUTES } from './constants/RoutingConstants';
import CheckingAccount from './screens/CheckingAccount/CheckingAccount';
import PaymentOrdersWithholdings from './screens/PaymentOrdersWithholdings/PaymentOrdersWithholdings';
import ExchangeDifference from './screens/ExchangeDifference/ExchangeDifference';
import Notifications from './screens/Notifications/Notifications';
import ClaimManagement from './screens/ClaimManagement/ClaimManagement';
import PurchaseOrders from './screens/PurchaseOrders/PurchaseOrders';
import ServicePage from './screens/ServicePage/ServicePage';
import MerchandiseRemittance from './screens/MerchandiseRemittance/MerchandiseRemittance';
import InventoriesContextProvider from './contexts/InventoriesContext';
import AppContextProvider from './contexts/AppContext';
import { STORAGE } from './constants/GlobalConstants';
import UsersAdministration from './screens/UsersAdministration/UsersAdministration';
import PasswordManagement from './screens/Login/PasswordManagement';
import CredentialsRequest from './screens/Login/CredentialsRequest';
import { AnimatedSwitch } from 'react-router-transition';
import { makeStyles } from '@material-ui/core';
import MyAccount from './screens/MyAccount/MyAccount';
import Logistics from './screens/Logistics/Logistics';
import ClaimStats from './screens/ClaimStats/ClaimStats';
import ComunicationSites from './screens/ComunicationSites/ComunicationSites';
import HelpInformation from './screens/HelpInformation/HelpInformation';
import Scraps from './screens/Scraps/Scraps'
import EmployeesAdministration from './screens/EmployeesAdministration/EmployeesAdministration'

import MaterialsRequires from './screens/MaterialsRequires/MaterialsRequires';
import QualityCertificateRequests from './screens/QualityCertificateRequests/QualityCertificateRequests';
import ExcludedSuppliers from './screens/ExcludedSupplierQualityCertificate/ExcludedSupplierQualityCertificate';
import ExcludedPurchaseOrders from './screens/ExcludedCertificatePurchaseOrders/ExcludedCertificatePurchaseOrders';
import Employees from './screens/Employees/Employees';
import ActivityLogs from './screens/ActivityLogs/ActivityLogs';
import EmailNotification from './screens/EmailNotification/EmailNotification';

function mapStyles(styles) {
  return {
    opacity: styles.opacity,
    transform: `scale(${styles.scale})`,
    transitionTimingFunction: 'ease-in-out',
  };
}

const useStyles = makeStyles(theme => ({
  routeWrapper: {
    position: 'relative',
    '& > div': {
      position: 'absolute',
    },
  },
}));

const AppRoutes = () => {
  const classes = useStyles();
  return (
    <Switch>
      <CustomThemeProvider>
        <Route path={ROUTES.LOGIN.PATH}>
          <Switch>
            <Route exact path={ROUTES.LOGIN.SUPPLIER} component={() => <Login isSupplier />} />
            <Route exact path={ROUTES.LOGIN.USER} component={Login} />
            <Route exact path={ROUTES.LOGIN.SIGN_UP} component={CredentialsRequest} />
            <Route exact path={ROUTES.LOGIN.CONFIRM} component={PasswordManagement} />
            <Route exact path={ROUTES.LOGIN.RECOVERY} component={() => <CredentialsRequest forgotPassword />} />
            <Route exact path={ROUTES.LOGIN.PASSWORD_CHANGE} component={() => <PasswordManagement forgotPassword />} />
            <Redirect from="/" to={ROUTES.LOGIN.USER} />
          </Switch>
        </Route>

        <Route path={ROUTES.PATH} exact>
          <HomeLayout>
            <AnimatedSwitch
              atEnter={{ opacity: 0, scale: 0.95 }}
              atLeave={{ opacity: 0, scale: 1.05 }}
              atActive={{ opacity: 1, scale: 1 }}
              mapStyles={mapStyles}
              className={classes.routeWrapper}>
              <Route exact path={ROUTES.PAYMENT_ORDERS_WITHHOLDINGS} component={PaymentOrdersWithholdings} />
              <Route exact path={ROUTES.CHECKING_ACCOUNT} component={CheckingAccount} />
              <Route exact path={ROUTES.EXCHANGE_DIFFERENCE} component={ExchangeDifference} />
              <Route exact path={ROUTES.PURCHARSE_ORDERS} component={PurchaseOrders} />
              <Route exact path={ROUTES.NOTIFICATIONS} component={Notifications} />
              <Route exact path={ROUTES.CLAIM_MGMT} component={ClaimManagement} />
              <Route exact path={ROUTES.CLAIM_STATS} component={ClaimStats} />
              <Route exact path={ROUTES.SERVICE_PAGE} component={ServicePage} />
              <Route exact path={ROUTES.MERCHANDISE_REMITTANCE} component={MerchandiseRemittance} />
              <Route exact path={ROUTES.LOGISTICS} component={Logistics} />
              <Route exact path={ROUTES.USER_ADMINISTRATION} component={UsersAdministration} />
              <Route exact path={ROUTES.EMPLOYEE_ADMINISTRATION} component={EmployeesAdministration} />
              <Route exact path={ROUTES.MY_ACCOUNT} component={MyAccount} />
              <Route exact path={ROUTES.COMUNICATION_SITES} component={ComunicationSites} />
              <Route exact path={ROUTES.HELP_INFORMATION} component={HelpInformation} />
              <Route exact path={ROUTES.SCRAPS} component={Scraps}/>
              <Route exact path={ROUTES.MATERIALS_REQUIRES} component={MaterialsRequires} />
              <Route exact path={ROUTES.QUALITY_CERTIFICATE_REQUESTS} component={QualityCertificateRequests} />
              <Route exact path={ROUTES.EXCLUDED_SUPPLIERS_CERTIFICATE} component={ExcludedSuppliers} />
              <Route exact path={ROUTES.EXCLUDED_PURCHASE_ORDERS} component={ExcludedPurchaseOrders} />
              <Route exact path={ROUTES.EMAIL_NOTIFICATION} component={EmailNotification}/>
              <Route exact path={ROUTES.EMPLOYEES} component={Employees}/>
              <Route exact path={ROUTES.ACTIVITY_LOGS} component={ActivityLogs}/>
              
              <Redirect from={ROUTES.HOME} to={ROUTES.CHECKING_ACCOUNT} />
              <Redirect from="/" to={ROUTES.CHECKING_ACCOUNT} />
            </AnimatedSwitch>
          </HomeLayout>
        </Route>

        {STORAGE.get(STORAGE.LOGOUT) ? (
          <Route exact path="/">
            <Redirect from="/" to={STORAGE.get(STORAGE.LOGOUT)} />
          </Route>
        ) : (
          <Route exact path="/">
            <Redirect from="/" to={ROUTES.LOGIN.USER} />
          </Route>
        )}
      </CustomThemeProvider>
    </Switch>
  );
};

const App = () => {
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.8)), url(${process.env.PUBLIC_URL}/images/logo.png)`,
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
      }}>
      <AppContextProvider>
        <InventoriesContextProvider>
          <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASENAME}>
            <AppRoutes />
          </BrowserRouter>
        </InventoriesContextProvider>
      </AppContextProvider>
    </div>
  );
};

export default App;
